import {
  Box,
  Grid,
  GridItem,
  Image,
  useStyleConfig,
  Link,
  Flex,
  Button,
  Heading,
  Center,
  Text, Input,
} from '@chakra-ui/react';
import BorderBox from '../../components/Wrappers/BorderBox';
import { progressiveFormStepper } from '../../components/ProgressiveFormStepper/utils';
import { exitToMenu } from '../utils';
import { getSectionIndex, getUsefulVars } from '../../handlers/helpers';
import { download, editResults, handleAptitudeResults, saveTest } from './utils';
import React from 'react';
import { onLink } from '../../handlers';
import { FaDownload } from 'react-icons/fa';
import { fetchMoreBullets } from '../../formElements/Bullets/Navigation/utils';
import { transformRSInput } from '../../formControllers/Transformation/Utils';
import TestLink from './TestLink';
import InfoLink from './InfoLink';
import RSSpinner from '../../components/RSSpinner';


const Aptitude = ({ props }) => {
  const uv = getUsefulVars(props);
  const sectionIndex = uv.stateProps.sectionData.sectionIndex;
  const variant = 'wrapper';
  const styles = {};
  styles.aptitude = useStyleConfig('Aptitude', { variant });
  styles.button = useStyleConfig('Button', { variant });

  const aptitude = uv.stateProps.dataToSave.saved.resumes ? uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['new-aptitude'] : [];
  const aptitudeImage1 = uv.stateProps.domain + '/app/images/aptitude_assessment.png';
  const aptitudeImage2 = uv.stateProps.domain + '/app/images/aptitude_results1.png';
  const aptitudeResults = aptitude?.[0]?.aptitude_results || null;
  const placeholder = '';
  const hollandCode = aptitude?.[0]?.holland_code ? aptitude[0].holland_code : placeholder;
  const myersBriggs = aptitude?.[0]?.myers_briggs ? aptitude[0].myers_briggs : placeholder;
  const valuesAssessment = aptitude?.[0]?.values_assessment ? aptitude[0].values_assessment : placeholder;
  const discInventory = aptitude?.[0]?.disc_inventory ? aptitude[0].disc_inventory : placeholder;
  const educationLevel = aptitude?.[0]?.education_level ? aptitude[0].education_level : placeholder;
  const salaryRange = aptitude?.[0]?.salary_range ? aptitude[0].salary_range : placeholder;
  const appType = window.appType;
  if (aptitudeResults === null) {

    return (
      <Box sx={{ ...styles.aptitude }}>
        <Box paddingBottom="16px" position='relative'>
          <Heading  variant="sectionHeading">Career Matchmaker</Heading>
        </Box>
        <Box className="aptitudeWrapper">
          <Box className="heroImageBox heroImageLeft"
               margin='0 1rem'
               marginRight='1rem !important;'
               marginLeft='1rem !important;'
               marginTop='10% !important;'
               width='30%'
          display={['none', 'none', 'none', 'flex']}
          alignItems='center'
          alignSelf='center'
          >
            <Image className="heroImageImg" src={aptitudeImage1} />
          </Box>
          <Box width="100%">
            <Box area="form" className="aptitudeFormWrapper">
              <Heading paddingLeft="8px" fontSize="26px" marginLeft="1.8rem">Get Personalized Career Options</Heading>

              <Box paddingLeft="8px" paddingBottom="1.5rem" marginLeft="1.8rem" width="90%">Career aptitude assessments
                are a powerful way to find out what jobs match your skills. Enter your results to get a list of
                AI-friendly                 careers that will be a great fit.</Box>
              <TestLink props={props} qObj={props.sections.question_parts[0]} testName="holland-code"
                        value={hollandCode} />
              <Box className='testLinkDescription'>The activities and environments that naturally interest you.</Box>
              <TestLink props={props} qObj={props.sections.question_parts[4]} testName="disc-inventory"
                        value={discInventory} />
              <Box className='testLinkDescription'>How naturally think, make decisions, and work with a team.</Box>
              <TestLink props={props} qObj={props.sections.question_parts[2]} testName="myers-briggs"
                        value={myersBriggs} />
              <Box className='testLinkDescription'>Your behavioral style and how you act in work situations.</Box>
              <TestLink props={props} qObj={props.sections.question_parts[3]} testName="values-assessment"
                        value={valuesAssessment} />
              <Box  className='testLinkDescription'>What you need from work to feel satisfied and engaged.</Box>
              <InfoLink props={props} qObj={props.sections.question_parts[5]} value={educationLevel} />
              <InfoLink props={props} qObj={props.sections.question_parts[6]} value={salaryRange} />
            </Box>
            <Button sx={{ ...styles.button.primary, ...styles.button.singleSectionMenu }}  className="aptitudeButton"
                    onClick={() => handleAptitudeResults(props)}>
              Results
            </Button>
          </Box>
        </Box>
        <Box>
          {appType === '' && (
            <Button
              sx={{ ...styles.button.primary, ...styles.button.singleSectionMenu }}
              onClick={() => exitToMenu(props)}
            >
              &lt;&lt; Menu
            </Button>

          )}
        </Box>
      </Box>
    );
  } else {

    return (

      <Box sx={{ ...styles.aptitude }}>
        <Box className="aptitudeWrapper" border="none !important">
          <Box area="form" className="aptitudeFormWrapper">
            <Heading>Results</Heading>
            <Text>See below for a list of careers that would be a great fit for you based on your aptitude
              assessment.</Text>
            <Box className="aptitudeEditBox">
              <Box className="aptitudeEditInnerBox">
                <Box className="aptitudeBox"><Text className="bold">Holland Code:</Text> {hollandCode}
                </Box>
                <Box className="aptitudeBox"><Text className="bold">Myers
                  Briggs:</Text> {myersBriggs}</Box>
                <Box className="aptitudeBox"><Text className="bold">Values
                  Assessment:</Text> {valuesAssessment}</Box>
                <Box className="aptitudeBox"><Text className="bold">Disc Inventory:</Text> {discInventory}
                </Box>
              </Box>
            </Box>


            <Box className="results">
              <Box className="resultsInner">

                <Box fontWeight="bold" padding="1rem 0" fontSize="22px">Recommended Careers</Box>
                <Box>
                  <ol>
                    {Object.values(aptitudeResults).map((assessment) => {
                      const textLines = assessment.text.split('\\n');
                        return (
                          <Box paddingBottom="2rem">
                            <Box fontWeight="bold" fontSize="18px">{assessment.title}</Box>
                            <Box padding="1rem 0" >

                              {textLines.map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  {index < textLines.length - 1 && <br />}
                                </React.Fragment>
                              ))}
                            </Box>
                            <Link paddingBottom="2rem" color="blue" href={assessment.link} isExternal>Read
                              More: {assessment.link}</Link>
                          </Box>
                        );
                      },
                    )}
                  </ol>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="heroImageBox heroImageRight">
            <Image className="heroImageImg" src={aptitudeImage2} />
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" width={['100%', '100%', '100%', '900px']}
             padding={[0, 0, 0, '0 0 0 2rem']}>
          {appType !== 'cm' && (
            <Box className="editButtonWrap">
              <Button
                sx={{ ...styles.button.primary, ...styles.button.singleSectionMenu }}
                onClick={(e) => {
                  onLink(false, uv.formikProps, uv.stateProps, 'menu');
                }}>&lt;&lt; Menu</Button>
            </Box>
          )}
          <Box className="editButtonWrap">
            <Button marginTop="1rem" onClick={(e) => {
              editResults(props);
            }}>Start Over</Button>
          </Box>
          {appType !== 'cm' && (
            <Box className="editButtonWrap">
              <Button
                marginTop="1rem !important"
                variant="download"
                leftIcon={<FaDownload />}
                sx={{ ...styles.button.download }}
                onClick={e => download(uv, aptitudeResults)}>
                Download
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    );
  }
};

export default Aptitude;